import classnames from 'classnames';
import React from 'react';

import { DisplayNameProps } from './types';

export const DisplayName: React.FC<DisplayNameProps> = ({
  hasMessage,
  content,
}) => {
  return (
    <div className="downloader__display-name-container">
      <p
        className={classnames('downloader__display-name', {
          'downloader__display-name--bold': hasMessage,
        })}
      >
        {content}
      </p>
    </div>
  );
};
